//
//
//
//
//
//
//
//

export default {
  props: {
    value: Boolean,
  },
  computed: {
    classes () {
      return {
        'k-icon-hamburger__burger--opened': this.value,
      }
    },
  }
}
